import { Component } from "@angular/core";
import { CommonModule } from "@angular/common";

@Component({
  selector: "app-cookie-consent-sub",
  imports: [CommonModule],
  templateUrl: "./cookie-consent-sub.component.html",
  styleUrls: ["./cookie-consent-sub.component.scss"],
})
export class CookieConsentSubComponent {}
